<template>
  <b-row>
    <b-col cols="12" lg="1">
      <h5 v-bind:class="{ 'text-center mt-2': mobileView }">#{{ (index + 1) }}</h5>
    </b-col>
    <b-col cols="12" lg="4">
      <div class="form-group">
        <fg-input>
          <el-select
            class="select-default"
            :placeholder="$t('views.automats.servicemanitemsreturning.position.idExsbItem')"
            filterable
            v-model="item.idExsbItem">
            <el-option v-for="option in exsbItemsOptions"
                       class="select-default"
                       :value="option['@id']"
                       :label="option.name"
                       :key="option['@id']">
            </el-option>
          </el-select>
        </fg-input>
      </div>
    </b-col>
    <b-col cols="12" lg="3">
      <div class="form-group">
        <fg-input>
          <el-select
            class="select-default"
            :placeholder="$t('views.automats.servicemanitemsreturning.position.idExsbWarehouse')"
            filterable
            v-model="item.idExsbWarehouse">
            <el-option v-for="option in exsbWarehousesOptions"
                       class="select-default"
                       :value="option['@id']"
                       :label="option.name"
                       :key="option['@id']">
            </el-option>
          </el-select>
        </fg-input>
      </div>
    </b-col>
    <b-col cols="12" lg="2">
      <input
              v-model="item.quantity"
              class="form-control"
              min="1"
              type="number"
              :placeholder="$t('views.automats.servicemanitemsreturning.position.quantity')">
    </b-col>
    <b-col cols="12" lg="2">
      <b-btn v-bind:class="{ 'mt-2': mobileView }" class="m-0 w-100" @click="deletePosition(index)" variant="danger">{{ $t('buttons.delete') }}</b-btn>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: 'Position',
  computed: {
    mobileView () {
      return this.$store.state.mobileView
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    deletePosition: {
      type: Function,
      required: true
    },
    exsbWarehousesOptions: {
      type: Array,
      require: true
    },
    exsbItemsOptions: {
      type: Array,
      require: true
    }
  }
}
</script>
